module.exports = __webpack_public_path__ + "static/media/ab-testing-results.59746ace.png";